import React, { useState } from "react";
import ProductTable from "../../../../../../../Components/BoltTable/BoltTable";
import { useSelector } from "react-redux";
import { fetchOnlyProducts } from "../../../../../../../services/product.service";
import { AddCell, ProductCell, SizeWeightCell, StockCell } from "./ProductCells";

export default function ProductListView(props) {
  const { handlescrollpackage, StepCheck, headerButtons } = props;
  const user = useSelector((state) => state.user);
  const [productData, setproductData] = useState([]);

  const columns = [
    // {
    //   id: 0,
    //   label: "#",
    //   render: (row) => <>{row?.id ?? "-"}</>,
    //   width: "200px",
    // },
    // Four columns (the redesign): the photo as the row's add button, Product
    // (Name + Sku), Size & Weight (Dimensions + Weight) and Stock (Quantity +
    // one column per location). Same values; ProductCells.jsx.
    {
      id: 1,
      label: " ",
      render: (row) => <AddCell row={row} />,
      fixed: "left",
      width: "60px",
    },
    {
      id: 2,
      label: "Product",
      render: (row) => <ProductCell row={row} />,
      width: "520px",
    },
    {
      id: 3,
      label: "Size & Weight",
      render: (row) => <SizeWeightCell row={row} />,
      width: "210px",
    },
    {
      id: 4,
      label: "Stock",
      render: (row) => (
        <StockCell
          row={row}
          warehouses={user?.user_approved_warehouses}
          selected={StepCheck["Warehouses"]}
        />
      ),
      width: "270px",
    },
    // {
    //   id: 8,
    //   label: "Actions",
    //   render: (row) => (
    //     <>
    //       {" "}
    //       <div className="table_action__wrap">
    //         <Tooltip
    //           title={
    //             StepCheck["Warehouses"] ? "Click To Add" : "Select Warehouse"
    //           }
    //         >
    //           <div
    //             className="table_action__btn"
    //             onClick={() => handlescrollpackage(row)}
    //           >
    //             <BsPlus size={10} />
    //             Add
    //           </div>
    //         </Tooltip>
    //       </div>
    //     </>
    //   ),
    //   width: "200px",
    //   fixed: "right",
    // },
  ];

  // The per-location quantity columns (id 1000 + index) are the Stock
  // column's second line now. Their lots variant stays commented out:
    // columns.splice(insertIndex + 1, 0, {
    //   id: 2000 + index,
    //   label: warehouse?.warehouse?.name + " Lot", // Add label for product lots
    //   render: (row) => {
    //     const matchedWarehouse = row?.product_warehouse?.find(
    //       (item) => item?.warehouse_id == warehouse?.warehouse_id
    //     );

    //     return (
    //       <>
    //         {matchedWarehouse && matchedWarehouse?.product_lots?.length > 0 && (
    //           <>
    //             {matchedWarehouse?.product_lots?.map((lot, index) => (
    //               <div key={index}>
    //                 {lot?.name} ({lot?.product_pallets_sum_quantity})
    //               </div>
    //             ))}
    //           </>
    //         )}
    //       </>
    //     );
    //   },
    //   width: "5vw",
    // });

  const getAllProducts = async (page, perPage, filter) => {
    const response = await fetchOnlyProducts(page, perPage, filter);
    if (!response.error) {
      setproductData(response?.data?.result);
    } else {
    }
  };

  return (
    <>
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <ProductTable
          tableId="productListViewTableforShipper_v2"
          message={"No Products Available To Display!"}
          searchPlaceHolder={"Search Products"}
          getAllData={getAllProducts}
          data={productData}
          columns={columns}
          handleRowClick={handlescrollpackage}
          disableAutoResizing={true}
          isRowClick={
            StepCheck["Warehouses"] ? "Click To Add" : "Select a location"
          }
          headerButtons={headerButtons}
        />
      </div>
    </>
  );
}
